// @flow

import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import TechSpecsComponent from './techSpecs';
import { getTechSpecsForPdbIds, getBasePricesForPdbIds, type PdbPrices } from '../../../store/pdbComparison';
import type { TechSpecs as TechSpecsType } from '../../../store/pdbComparison/types';
import withPdbIdsFromStorage from '../withPdbIdsFromStorage';
import {
  getButtonOrderText,
  getButtonModelInfoText,
  getTechSpecsHeadingText,
  getRowHeadingPriceText,
  getRowHeadingMotorizationText,
  getRowHeadingFuelText,
  getRowHeadingPowerText,
  getRowHeadingConsumptionText,
  getRowHeadingTransmissionText,
  getRowHeadingNrOfDoorsText,
  getRowHeadingWeightText,
} from '../../../store/compareSettings/selectors';

type StateProps = {|
  specs: TechSpecsType,
  prices: PdbPrices,
  techSpecsHeadingText: string,
  orderLabel: string,
  moreInfoLabel: string,
  priceLabel: string,
|};

type Props = StateProps;

const TechSpecs = ({
  prices,
  specs,
  techSpecsHeadingText,
  orderLabel,
  moreInfoLabel,
  priceLabel,
}: Props) => (
  <TechSpecsComponent
    prices={prices}
    specs={specs}
    heading={techSpecsHeadingText}
    orderLabel={orderLabel}
    moreInfoLabel={moreInfoLabel}
    priceLabel={priceLabel}
  />
);

const translateSpecs = (specs, state) => ({
  [getRowHeadingMotorizationText(state)]: specs.engine,
  [getRowHeadingFuelText(state)]: specs.fuelType,
  [getRowHeadingPowerText(state)]: specs.power,
  [getRowHeadingConsumptionText(state)]: specs.consumption,
  [getRowHeadingTransmissionText(state)]: specs.transmission,
  [getRowHeadingNrOfDoorsText(state)]: specs.doors,
  [getRowHeadingWeightText(state)]: specs.weight,
});

const mapStateToProps = (state): StateProps => ({
  prices: getBasePricesForPdbIds(state),
  specs: translateSpecs(getTechSpecsForPdbIds(state), state),
  techSpecsHeadingText: getTechSpecsHeadingText(state),
  orderLabel: getButtonOrderText(state),
  moreInfoLabel: getButtonModelInfoText(state),
  priceLabel: getRowHeadingPriceText(state),
});

export default compose(
  withPdbIdsFromStorage,
  connect(mapStateToProps),
)(TechSpecs);
